import React from 'react';
import { observer } from 'mobx-react';

// Config
import { config, getSmarterElementsInstance } from '../../config';

const SmarterElements = getSmarterElementsInstance();

// Translations
import translate from '../Translate.js';

const AutomatedReview = observer(class AutomatedReview extends React.Component {

  componentDidMount() {
    const examSession = this.props.store.ExamStore.examSession;
    const { SessionStore } = this.props.store;
    const { userSid } = SessionStore.userData;
    const { token } = SessionStore;
    
    if (examSession.platformVersion === "3") {

      let SessionViewer = null;

      // get the position of the session viewer container
    // wait for the dom to be ready
      //document.addEventListener('DOMContentLoaded', function() {
      if(this && this.refs && this.refs["v3-container"] && SmarterElements){
        function resizeContainer() {
        
            const scontainer = document.getElementById('v3-container');
            const containerRect = scontainer.getBoundingClientRect();
            
            const containerTop = containerRect.top + 10;
            // get the px amoutn for the vh
            const vh = window.innerHeight;
            scontainer.style.height = vh - containerTop + 'px';
            
            if(SessionViewer){
                SessionViewer.updateConstraints({
                    maxHeight: vh - containerTop,
                }); 
                SessionViewer.recalculateSize();
            }
        }

        resizeContainer();
        
        // ensure that the resizing is performat...
        const debouncedResize = window.SmarterElements.throttle(() => {
            resizeContainer();
        }, 250);

        // add a lisenter that will run on document resize to resize the contaner
        window.addEventListener('resize', debouncedResize);
      }


      // Create a session viewer
      const viewerProperties = {
        sessionSid: examSession.sid,
        installSid: examSession.installSid,
        examSid: examSession.examSid,
        token: token,
        identity: userSid,
        viewMode: 'instructor',
        allowPopout: true,
        enabledComponents: {
          controls: true,
          sessionDetails: {
            tabs: ['info', 'identity', 'flags']
          }, 

          annotations: true,
          timeline: true,
        },  
        elementId: 'v3-container',
        autoResize: true,
        resizeOffset: 10,
      };

      SessionViewer = SmarterElements.create('proctoring/session-viewer', viewerProperties);
      SessionViewer.mount(this.refs["v3-container"]);
    }
  }

  render() {
    const { SessionStore } = this.props.store;
    const { installSid } = SessionStore.userData;
    const { examSid, sessionSid } = this.props;
    const { token } = SessionStore;
    const examSession = this.props.store.ExamStore.examSession;
   

    return (
      
      <span>
      
      {
        examSession.platformVersion === "3" ? (
          <div className="iframe-wrap" style={{ margin: '-15px', width: '100%', height: '100vh' }}>
            <style>
              {`
                .drawer__header {
                  top: 0;
                  position: sticky;
                }
                .drawer__content {
                  overflow: hidden;
                }
              `}
            </style>
              <div id="v3-container" ref="v3-container" style={{ width: '100%', height: 'calc(100vh - 62px)' }}></div>
            </div>
          ) : (
              <div className="iframe-wrap" style={{ marginTop: '0px', width: '100%', height: '100%' }}>
                <iframe
                  className="iframe--full"
                  allowFullScreen="true"
                  src={`${config.playbackUrl}/#/?installSid=${installSid}&examSid=${examSid}&sessionSid=${sessionSid}&token=${token}&embed=true`}
                ></iframe>
              </div>
        )}
      </span>
    )
  }
})

export default translate('AutomatedReview')(AutomatedReview);


// WEBPACK FOOTER //
// ./src/app/components/Sessions/AutomatedReview.js